import React, { Component } from 'react';
import { Container } from 'reactstrap';

export class Layout extends Component {
    static displayName = Layout.name;

    render() {
        return (
            <div className="layout-wrapper">
                <Container fluid className="layout-container">

                    <div className="content-wrapper">
                        {this.props.children}
                    </div>

                    <div dangerouslySetInnerHTML={{ __html: `<!-- ${process.env.REACT_APP_PAGE_HEADER} -->` }} />
                </Container>
            </div>
        );
    }
}
